import PropTypes from 'prop-types';
import ModalComponent from '../modal';
import ButtonComponent from '../button';
import { ConfirmationModalWrapper, ConfirmModalActions } from './confirmation-modal.style';

const ConfirmationModalComponent = ({
    type,
    width = 400,
    label = 'Confirmation',
    text = 'Are you sure...',
    close,
    actions = [
        { label: 'Cancel', type: 'button', outline: true, action: () => { } },
        { label: 'Submit', type: 'button', action: () => { } },
    ],
}) => {
    return (
        <ModalComponent type={type} close={close} label={label} width={width}>
            <ConfirmationModalWrapper>
                {text && <p>{text}</p>}

                {/* Actions */}
                {
                    actions && actions.length > 0 && (
                        <ConfirmModalActions>
                            {
                                actions.map((button, index) => (
                                    <ButtonComponent
                                        key={index}
                                        label={button.label}
                                        type={button.type}
                                        outline={button.outline}
                                        onClick={button.action}
                                        color={button.color || type}
                                    />
                                ))
                            }
                        </ConfirmModalActions>
                    )
                }
            </ConfirmationModalWrapper>
        </ModalComponent>
    );
};

ConfirmationModalComponent.propTypes = {
    type: PropTypes.oneOf(['default', 'success', 'error', 'warning']),
    width: PropTypes.number,
    label: PropTypes.string,
    text: PropTypes.string,
    close: PropTypes.func,
    actions: PropTypes.array,
};

export default ConfirmationModalComponent;
